import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { withRouter, useParams } from "react-router-dom";
import axios from "axios";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { withFirebase } from "../../firebase";
import Loading from "../../components/Loading";
import Tabs from "./tabs";
import { useTranslation } from "react-i18next";

const MenuSort = () => {
	const classes = useStyles();
	const { t } = useTranslation();
	const { brandId } = useParams();

	const [categories, setCategories] = useState(null);
	const [products, setProducts] = useState(null);
	const [typeSystem, setTypeSystem] = useState(false);

	const shops = useSelector((state) => state.shops.shops);
	const adminPermission = useSelector((state) => state.shops.adminPermission);
	const isNewAdmin = adminPermission?.newAdmin;

	const activeBrand = isNewAdmin
		? shops
				.flatMap((shop) => shop.brands)
				.find((brand) => brand.id === brandId && brand.isActive)
		: shops[brandId];

	const iikoAccount = activeBrand?.apiSettings?.iiko?.account;
	const posterAccount = activeBrand?.apiSettings?.poster?.account;
	const goPosAccount = activeBrand?.apiSettings?.goPos?.account;
	const goPosId = activeBrand?.appSettings?.organizationId;
	const categoriesOrder = activeBrand?.category.categoriesOrder || [];
	const hiddenCategories = activeBrand?.category.hiddenCategories || [];
	const hiddenProducts = activeBrand?.category.hiddenProducts || [];

	useEffect(() => {
		let isMounted = true;
		setCategories(null);
		setProducts(null);

		let source = null;

		if (iikoAccount) {
			source = { type: "iiko", account: iikoAccount };
			setTypeSystem("iiko");
		} else if (posterAccount) {
			source = { type: "poster", account: posterAccount };
			setTypeSystem("poster");
		} else if (goPosAccount) {
			source = { type: "goPos", account: goPosAccount };
			setTypeSystem("goPos");
		}

		if (source) {
			const fetchUrl =
				source.type === "iiko"
					? `https://e-api.com.ua/api/v1/iikoTransport/${source.account}/menu`
					: source.type == "poster"
					? `https://e-api.com.ua/api/v1/poster/${source.account}/menu?discounts=true`
					: `https://e-api.ithinkers.fun/api/v1/goPos/${source.account}/menu/${goPosId}`;
			axios
				.get(fetchUrl)

				// axios
				// 	.get(`https://e-api.com.ua/api/v1/iikoTransport/${iikoAccount}/menu`)
				// axios
				// .get(
				// 	`https://e-api.ithinkers.fun/api/v1/iikoTransport/${iikoAccount}/menu`
				// )
				.then((response) => {
					if (isMounted) {
						const parentCategories =
							activeBrand.category?.parentCategories?.filter(
								(item) => item && item.trim() !== ""
							);

						let filteredCategories = response.data.categories;

						if (parentCategories && parentCategories.length > 0) {
							filteredCategories = filteredCategories.filter((category) =>
								parentCategories.includes(category.parentGroup)
							);
						}

						const categoryIds = filteredCategories.map(
							(category) => category.id
						);

						const filteredProducts = response.data.products.filter(
							(product) =>
								categoryIds.includes(product.parentGroup) ||
								categoryIds.includes(product.categorieId)
						);

						if (source.type == "goPos") {
							const prepareCat = filteredCategories.map((item) => {
								const obj = { ...item, id: String(item.id) };
								return obj;
							});

							const prepareProd = filteredProducts.map((item) => {
								const obj = {
									...item,
									id: String(item.id),
									categorieId: String(item.categorieId),
									parentGroup: String(item.parentGroup),
								};
								return obj;
							});
							console.log(prepareProd);
							setCategories(prepareCat);
							setProducts(prepareProd);
						} else {
							setCategories(filteredCategories);
							setProducts(filteredProducts);
						}
					}
				})
			.catch((error) => {
					console.error("Failed to fetch menu:", error);
				});

			return () => {
				isMounted = false;
			};
		}
	}, [iikoAccount, goPosAccount, posterAccount]);

	console.log(categories);

	if (!categories) return <Loading size={32} color={"#326dff"} />;

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Paper className={classes.modal}>
					<div className={classes.wrapper}>
						<div className={classes.title}>{t("menuSort.title")}</div>
						<Tabs
							categories={categories}
							products={products}
							categoriesOrder={categoriesOrder}
							hiddenCategories={hiddenCategories}
							hiddenProducts={hiddenProducts}
							isNewAdmin={isNewAdmin}
							typeSystem={typeSystem}
						/>
					</div>
				</Paper>
			</Grid>
		</Grid>
	);
};

const useStyles = makeStyles({
	modal: {
		width: "100%",
		height: "auto",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		background: "white",
		borderRadius: 10,
	},
	wrapper: {
		width: "100%",
		padding: 16,
		paddingTop: 24,
		paddingBottom: 16,
		boxSizing: "border-box",
	},
	title: {
		fontSize: 21,
		fontFamily: "Roboto",
		fontWeight: "bold",
		lineHeight: 2,
		letterSpacing: "0.003em",
	},
});

export default withRouter(withFirebase(MenuSort));
